<div class="row container" style="margin:0 auto;margin-top: 50px;">
  <div class="col-md-6 grid-margin stretch-card">
    <div class="card">
      <a href="/avatar-framer"><img class="card-img-top" src="/assets/images/avatar-frame.png" alt="card images"></a>
      <!-- <img style="width:50%;" src="/assets/images/background.jpg" alt=""> -->
      <div class="card-body pb-0">
        <p>Tạo avatar theo khung hình Đại Hội Hội Liên Hiệp Thanh Niên Việt Nam Tỉnh Đồng Nai Lần Thứ VIII, Nhiệm Kỳ 2024 - 2029</p>
        <div style="text-align: center;"
          class="align-items-center justify-content-between text-muted border-top py-3 mt-3">
          <a href="/avatar-framer" class="btn btn-gradient-primary btn-fw" title="crop image">
            Tạo avatar
          </a>
        </div>
      </div>
    </div>

  </div>
  <div class="col-md-6 grid-margin stretch-card">
    <div class="card">
      <a href="/convert-img"><img class="card-img-top" src="/assets/images/background_kyvong.png" alt="card images"></a>
      <!-- <img style="width:50%;" src="/assets/images/background.jpg" alt=""> -->
      <div class="card-body pb-0">
        <!-- <h4><a href="/convert-img" class="text-danger">GỬI KỲ VỌNG</a></h4> -->
        <p>Gửi kỳ vọng đến Đại Hội Hội Liên Hiệp Thanh Niên Việt Nam Tỉnh Đồng Nai Lần Thứ VIII, Nhiệm Kỳ 2024 - 2029</p>
        <div style="text-align: center;"
          class="align-items-center justify-content-between text-muted border-top py-3 mt-3">
          <a href="/convert-img" class="btn btn-gradient-primary btn-fw" title="crop image">
           Kỳ vọng
          </a>
        </div>
      </div>
    </div>

  </div>

</div>